"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var StringLocalizer = /** @class */ (function () {
    function StringLocalizer() {
        this.getString = function (text, params) {
            if (params && text) {
                for (var property in params) {
                    if (params.hasOwnProperty(property)) {
                        text = text.replace('{' + property + '}', params[property]);
                    }
                }
            }
            return text;
        };
    }
    return StringLocalizer;
}());
exports.StringLocalizer = StringLocalizer;
exports.stringLocalizer = new StringLocalizer();
